import React from 'react';
import { Row, Col } from 'antd';
import styles from './FilterWrapper.module.scss';
import { useTranslation } from 'react-i18next';

const FilterWrapper = ({ children, rightChild, size="small", spacing = 4, containerStyle, custom = {}}) => {
	const { i18n, t } = useTranslation();
  const sizing = {
    "small":{
      xs:12,
      lg:3,
      xl:2
    },
    "medium" :{
      xs:24,
      lg:4,
      xl:3
    },
    "large" :{
      xs:24,
      lg:10,
      xl:6
    }
  }

  return (
    <div className={styles.container} style={containerStyle}>
      <Row style={{display:"flex", justifyContent:"space-around", width:"100%"}}>
        <Col xs={{ span: 24 }} lg={{ span: rightChild ? 20 : 24 }}>
          <Row className={styles.row}>
            {React.Children.map(children, (child, index) => {
              if (child && child !== null) {

                const defineSize = custom[index] ? sizing[custom[index]] : sizing[size];
                return (
                  <Col className={"mb-1"} xs={{ span: defineSize.xs }} lg={{ span: defineSize.lg }} xl={{ span: defineSize.xl }} style={{ paddingRight: spacing }}>
                    {child}
                  </Col>
                );
              }
            })}
          </Row>
        </Col>
        {rightChild &&
          <Col xs={{ span: 24 }} lg={{ span: 4 }} style={{ display: "flex", justifyContent:"end", alignItems:"self-start", paddingRight: spacing }}>
            {rightChild}
          </Col>
        }
      </Row>
    </div>
  );
};

export default FilterWrapper;
